import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { AdminAuditScreen } from '@/features/admin/AdminAuditScreen';

type Search = { page?: number };

export const Route = createFileRoute('/_app/admin/audit')({
  validateSearch: (s: Record<string, unknown>): Search => ({
    page: typeof s.page === 'number' && s.page >= 1 ? Math.floor(s.page) : undefined,
  }),
  component: () => {
    const { page } = Route.useSearch();
    const navigate = useNavigate();
    return <AdminAuditScreen page={page ?? 1} onPageChange={(p) => void navigate({ to: '/admin/audit', search: { page: p } })} />;
  },
});
